import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useHashScrollGlow } from "@/hooks/useHashScrollGlow";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let anchor links handle their own scroll
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname, hash]);

  // Scroll to hash targets and apply a slow glow animation
  useHashScrollGlow();

  return null;
};

export default ScrollToTop;
